import classnames from 'classnames';

import { useTabMenu } from '../use-tab-menu';

import * as S from './sub-menu.styles';
import { useSubMenu } from './use-sub-menu';

export const TabMenuSubMenuTestId = {
  showMore: 'tab-menu-show-more',
  panelWrapper: 'tab-menu-sub-menu-panel-wrapper',
  panel: 'tab-menu-sub-menu-panel',
};

export const SubMenu = () => {
  const { state } = useTabMenu();
  const { size, hiddenItems, subMenuOpened, isPrimary, customApplicationUrl } = state;
  const { isCurrentlyActive } = useSubMenu({ customApplicationUrl });

  return (
    <S.SubMenuPanelWrapper
      role="presentation"
      className={classnames(
        {
          primary: !!isPrimary,
          invisible: !subMenuOpened,
        },
        [size.toLowerCase()],
      )}
      data-testid={TabMenuSubMenuTestId.panelWrapper}
    >
      <S.SubMenuPanel data-testid={TabMenuSubMenuTestId.panel} role="presentation">
        {hiddenItems.map((item) => {
          const isActive = isCurrentlyActive(item.url);
          return (
            <S.SubMenuItemWrapper
              key={item.id}
              className={classnames({ active: isActive })}
            >
              <S.SubMenuItem {...item} role="presentation" isSubMenuItem />
              {isActive && <S.ActiveIcon />}
            </S.SubMenuItemWrapper>
          );
        })}
      </S.SubMenuPanel>
    </S.SubMenuPanelWrapper>
  );
};
